export default "__VITE_ASSET__DveFCyNF__"